
/**
 * 课程分类
 */

 export const CourseCategoryList=[
    {
        prop:"id",
        label:"id",
        width:"150",
        format: "",
        order: false,
        isShow:false
    },
    {
        prop:"name",
        label:"分类名称",
        width:"300",
        format: "",
        order: false,
        isShow:true
    },
    {
        prop:"code",
        label:"编号",
        width:"150",
        format: "",
        order: false,
        isShow:true
    },
    {
        prop:"levlel",
        label:"分类级别",
        width:"150",
        format: "",
        order: false,
        isShow:true
    },
    {
        prop:"isLeaf",
        label:"是否子分类",
        width:"150",
        format: "isLeaf",
        order: false,
        isShow:true
    },
    {
        prop:"levelNumber",
        label:"优先级",
        width:"150",
        format: "",
        order: false,
        isShow:true
    },
    {
        prop:"creatorName",
        label:"创建人",
        width:"150",
        format: "",
        order: false,
        isShow:true
    },
    {
        prop:"creationTime",
        label:"创建时间",
        width:"150",
        format: "datetime",
        order: false,
        isShow:true
    }
 ]

